import React, {Component} from 'react';

class GoogleMapStyle extends Component {

    render() {
        return (
            // Important! Always set the container height explicitly
            <div className="google-map-style-1">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.81724734588!2d36.81880731395784!3d-1.2835211359832293!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f1190165629fb%3A0xd869645fa6ebc625!2sMixon%20Softwares!5e0!3m2!1sen!2ske!4v1655853343491!5m2!1sen!2ske"
                    width="100%" height="100%" style={{border: 0, borderRadius: 15}} allowFullScreen="" loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
        );
    }
}

export default GoogleMapStyle;